import {useNavigate, useParams} from "react-router-dom";
import PageLayout from "@/Themes/Default/Layouts/PageLayout";
import {useQueryClient} from "@tanstack/react-query";
import {useToastMessagesStore} from "@/Stores/ToastMessagesStore";
import {QueryKeys} from "@/Service/Api/V1/QueryKeys/QueryKeys";
import {can} from "@/Util/permissionChecks";
import {useGetGtaRate} from "@/Service/Api/V1/ApiHooks/GtaRates/useGetGtaRate";
import {useUpdateGtaRate} from "@/Service/Api/V1/ApiHooks/GtaRates/useUpdateGtaRate";
import GtaRateForm, {GtaRateFormData} from "@/Components/Forms/GtaRateForm";
import {sleep, url} from "@/Helpers/general";

const GtaRatePage = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();
    const addToastMessage = useToastMessagesStore((state) => state.addToastMessage);

    const {gtaRateId} = useParams();
    const {data: gtaRate} = useGetGtaRate({
        requestParams: {
            gta_id: gtaRateId as string
        },
        enabled: !!gtaRateId
    });
    const {mutateAsync: updateGtaRate, isPending} = useUpdateGtaRate();

    const handleUpdateGtaRate = async (data: GtaRateFormData) => {
        await updateGtaRate({
            gta_id: gtaRate?.id as unknown as string,
            UpdateGtaRequest: data
        }, {
            onSuccess: async () => {
                await queryClient.invalidateQueries({
                    queryKey: QueryKeys.gtaRates._def
                });
                addToastMessage({
                    severity: 'success',
                    summary: 'GTA Rate updated',
                    detail: 'GTA Rate has been updated successfully',
                });
                await sleep(2000)
                navigate(url('gta-rates'));
            },
        });
    };

    return (
        <PageLayout>
            <GtaRateForm
                initFormData={{
                    ...gtaRate,
                    daily_hire_rate: Number(gtaRate?.daily_hire_rate),
                }}
                onSubmit={handleUpdateGtaRate}
                isProcessing={isPending}
                onSubmitButtonLabel='Update GTA Rate'
                onSubmitButtonDisabled={!can('update:gta')}
            />
        </PageLayout>
    );
};
export default GtaRatePage;